<template>
    <Button :label="label" :loading="loading" :size="size" />
</template>

<script setup lang="ts">
    import Button from 'primevue/button';

    // Props
    withDefaults(defineProps<{
        label?: string,
        loading?: boolean,
        size?: 'small' | 'large'
    }>(), {
        size: 'small'
    });
</script>